import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const Support = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    account_id: '',
    issue_type: '',
    priority: '',
    subject: '',
    description: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const { data, error } = await supabase
        .from('support_tickets')
        .insert([{
          ...formData,
          created_at: new Date().toISOString(),
          status: 'open'
        }]);

      if (error) throw error;

      setSubmitMessage('Your support ticket has been submitted successfully. We will respond within 24 hours.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        account_id: '',
        issue_type: '',
        priority: '',
        subject: '',
        description: ''
      });
    } catch (error) {
      setSubmitMessage('There was an error submitting your support request. Please try again.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Customer Support</h1>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '3rem', alignItems: 'start'}}>
            <div>
              <h2 style={{color: '#2563eb', marginBottom: '1.5rem'}}>Get Help</h2>
              <p style={{marginBottom: '2rem', lineHeight: '1.8'}}>
                Our support team is here to help you with any questions or issues you may have 
                with our SMS marketing services. We provide support to ensure your campaigns 
                run smoothly and effectively through our partnerships with leading SMS providers.
              </p>

              <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #2563eb'}}>
                <h3 style={{color: '#2563eb', marginBottom: '1rem'}}>Support Hours</h3>
                <p><strong>Business Hours:</strong></p>
                <p>Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                <p>Saturday - Sunday: Closed</p>
                <p style={{marginTop: '1rem', fontSize: '0.9rem'}}>
                  We respond to all support requests via email within 24-48 business hours.
                </p>
              </div>

              <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
                <h3 style={{color: '#2563eb', marginBottom: '1rem'}}>Contact Methods</h3>
                <p><strong>Primary Email:</strong> support@meesmarketing.com</p>
                <p><strong>General Inquiries:</strong> info@meesmarketing.com</p>
                <p><strong>Business Address:</strong></p>
                <p>MEES HOLDINGS INC<br />
                2022 E 9TH ST<br />
                BROOKLYN, NY 11223</p>
              </div>

              <div style={{background: '#f0fdf4', padding: '2rem', borderRadius: '10px', border: '2px solid #16a34a'}}>
                <h3 style={{color: '#16a34a', marginBottom: '1rem'}}>Response Times</h3>
                <p><strong>Urgent Issues:</strong> Within 24 business hours</p>
                <p><strong>Standard Issues:</strong> Within 24-48 business hours</p>
                <p><strong>General Inquiries:</strong> Within 48 business hours</p>
                <p style={{marginTop: '1rem', fontSize: '0.9rem'}}>
                  All times are based on business days (Monday-Friday, excluding holidays)
                </p>
              </div>
            </div>

            <div className="form-container">
              <h2 style={{color: '#2563eb', marginBottom: '1.5rem'}}>Submit Support Request</h2>
              
              {submitMessage && (
                <div style={{
                  background: submitMessage.includes('error') ? '#fef2f2' : '#f0fdf4',
                  color: submitMessage.includes('error') ? '#ef4444' : '#16a34a',
                  padding: '1rem',
                  borderRadius: '5px',
                  marginBottom: '1.5rem',
                  border: `2px solid ${submitMessage.includes('error') ? '#ef4444' : '#16a34a'}`
                }}>
                  {submitMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="account_id">Account ID (if applicable)</label>
                  <input
                    type="text"
                    id="account_id"
                    name="account_id"
                    value={formData.account_id}
                    onChange={handleChange}
                    placeholder="Your account ID or username"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="issue_type">Issue Type *</label>
                  <select
                    id="issue_type"
                    name="issue_type"
                    value={formData.issue_type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select issue type</option>
                    <option value="technical">Technical Issue</option>
                    <option value="billing">Billing Question</option>
                    <option value="delivery">Message Delivery Problem</option>
                    <option value="compliance">Compliance Question</option>
                    <option value="api">API Integration</option>
                    <option value="account">Account Management</option>
                    <option value="feature">Feature Request</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="priority">Priority Level *</label>
                  <select
                    id="priority"
                    name="priority"
                    value={formData.priority}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select priority</option>
                    <option value="low">Low - General question</option>
                    <option value="medium">Medium - Non-urgent issue</option>
                    <option value="high">High - Affecting operations</option>
                    <option value="critical">Critical - Service down</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Brief description of the issue"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="description">Detailed Description *</label>
                  <textarea
                    id="description"
                    name="description"
                    rows="6"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Please provide as much detail as possible about your issue, including any error messages, steps to reproduce, and what you expected to happen."
                    required
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Support Request'}
                </button>
              </form>

              <p style={{fontSize: '0.9rem', color: '#6b7280', marginTop: '1rem', textAlign: 'center'}}>
                For urgent issues, please email support@meesmarketing.com with "URGENT" in the subject line. 
                We will respond as quickly as possible during business hours.
              </p>
            </div>
          </div>

          <div style={{marginTop: '4rem'}}>
            <h2 style={{color: '#2563eb', marginBottom: '2rem', textAlign: 'center'}}>Frequently Asked Questions</h2>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem'}}>
              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '10px'}}>
                <h4 style={{color: '#2563eb', marginBottom: '0.5rem'}}>How do I get started with SMS marketing?</h4>
                <p style={{fontSize: '0.95rem', lineHeight: '1.6'}}>
                  Contact our team to discuss your needs. We'll help you set up your account, register your campaigns, 
                  and ensure compliance with all regulations.
                </p>
              </div>

              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '10px'}}>
                <h4 style={{color: '#2563eb', marginBottom: '0.5rem'}}>What compliance requirements do I need to meet?</h4>
                <p style={{fontSize: '0.95rem', lineHeight: '1.6'}}>
                  You need proper consent from recipients, clear opt-out mechanisms, and compliance with TCPA and 
                  CAN-SPAM regulations. We help ensure full compliance.
                </p>
              </div>

              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '10px'}}>
                <h4 style={{color: '#2563eb', marginBottom: '0.5rem'}}>How quickly are messages delivered?</h4>
                <p style={{fontSize: '0.95rem', lineHeight: '1.6'}}>
                  Most messages are delivered within seconds. Delivery times may vary based on carrier and message volume.
                </p>
              </div>

              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '10px'}}>
                <h4 style={{color: '#2563eb', marginBottom: '0.5rem'}}>Can I integrate with my existing systems?</h4>
                <p style={{fontSize: '0.95rem', lineHeight: '1.6'}}>
                  Yes, we provide robust APIs and integrations with popular CRM and marketing platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Support;